/* Presentation only: align native title and price rows after facets update. */
if (!customElements.get('ln-perfumes-grid')) {
  customElements.define('ln-perfumes-grid', class extends HTMLElement {
    connectedCallback() {
      this.priceDetails = new WeakSet();
      this.schedule = () => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(() => this.alignRows()); };
      this.mutations = new MutationObserver(this.schedule);
      this.mutations.observe(this, { childList: true, subtree: true });
      this.resize = new ResizeObserver(entries => {
        const width = entries[0].contentRect.width;
        if (width !== this.width) { this.width = width; this.schedule(); }
      });
      this.resize.observe(this);
      document.fonts.ready.then(() => { if (this.isConnected) this.schedule(); });
      this.schedule();
    }
    disconnectedCallback() { cancelAnimationFrame(this.frame); this.mutations?.disconnect(); this.resize?.disconnect(); }
    alignRows() {
      if ((window.Shopify?.locale || 'en').startsWith('en')) {
        const heading = this.querySelector('.active-facets-vertical-filter h2');
        if (heading && heading.textContent.trim().endsWith(':')) heading.textContent = heading.textContent.trim().slice(0, -1);
        const clear = this.querySelector('.active-facets-vertical-filter .active-facets__button-remove span');
        if (clear && clear.textContent !== 'Clear all') clear.textContent = 'Clear all';
      }
      this.querySelectorAll('#FacetFiltersForm details').forEach(details => {
        const price = details.querySelector('price-range');
        const label = details.querySelector('summary span');
        const currency = window.Shopify?.currency?.active;
        if (price && label && currency && label.textContent.trim() === 'Price') label.textContent = `Price (${currency})`;
        if (price && !this.priceDetails.has(details)) { details.open = true; this.priceDetails.add(details); }
      });
      const cards = [...this.querySelectorAll('#product-grid > li .ln-perfume-card')];
      cards.forEach(card => { card.style.removeProperty('--ln-title-height'); card.style.removeProperty('--ln-price-height'); });
      const rows = [];
      cards.forEach(card => {
        const top = card.getBoundingClientRect().top;
        let row = rows.find(row => Math.abs(row.top - top) < 2);
        if (!row) { row = { top, cards: [] }; rows.push(row); }
        row.cards.push(card);
      });
      rows.forEach(row => {
        const titleHeight = Math.max(...row.cards.map(card => card.querySelector('.card > .card__content .card__heading')?.getBoundingClientRect().height || 0));
        const priceHeight = Math.max(...row.cards.map(card => card.querySelector('.price')?.getBoundingClientRect().height || 0));
        row.cards.forEach(card => { card.style.setProperty('--ln-title-height', `${titleHeight}px`); card.style.setProperty('--ln-price-height', `${priceHeight}px`); });
      });
    }
  });
}
